@if (visible()) {
  <div class="pager">
    <button
      type="button"
      class="nav"
      aria-label="Previous version"
      [disabled]="disabled() || previousId() === null"
      (click)="navigate(previousId())"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          d="M15 5 8 12l7 7"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>

    <div class="label">
      <span
        >Version: <strong>{{ position() }} of {{ total() }}</strong></span
      >
      <span class="muted">{{ date() | date: 'MMM d, y' }}</span>
      @if (actorLabel()) {
        <span class="muted">| {{ actorLabel() }}</span>
      }
    </div>

    <button
      type="button"
      class="nav"
      aria-label="Next version"
      [disabled]="disabled() || nextId() === null"
      (click)="navigate(nextId())"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          d="M9 5l7 7-7 7"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
}
